module.exports = __webpack_public_path__ + "assets/img/Nexon-4-Landing-Page-w960.d232fd5b.webp";